import { Fade } from "react-awesome-reveal";
import './style.css'

function Banner() {
    return (
        <div className="banner">
            <div>
                <Fade cascade triggerOnce={true} className="info">
                    <span className="font-xl bold">Hi, I'm Wagner</span>
                    <span className="font-lg bold text-secondary">Front-end Engineer</span>                    
                    <span className="title-text">Building scalable, high-performance web experiences for global products</span> 
                    <a href="#contact">Contact me!</a>
                </Fade>
            </div>
        </div>
    )
}

export default Banner;